







































































import { Component } from 'vue-property-decorator';
import { StaffEntity } from '@/entities/staff.entity';
import ThanksBtnPc from '@/components/ViewComponent/Thanks/AddThanksMessage/ThanksBtn/ThanksBtnPc.vue';
import SingleUserBaseMixin from '../ViewComponent/Thanks/AddThanksMessage/single-user-base.mixin';

@Component<UserAvatar>({
  components: { ThanksBtnPc },
  computed: {
    /**
     * Compute to show thanks messages button
     */
    isShowThanksBtn() {
      return !this.isCurrentStaff && this.getUser.isActive;
    }
  }
})
export default class UserAvatar extends SingleUserBaseMixin {
  currentStaff!: StaffEntity;
  isLoading = false;
  isShowAvatar = false;

  async created(): Promise<void> {
    if (this.staffId && this.isShowAvatar) {
      await this.fetchStaffById(this.staffId);
    }
  }

  /**
   * Check current user login 
   */ 
   get isCurrentStaff(): boolean {
    return this.currentStaff.id === this.staffId;
  }

  /**
   *  Get user before show showAvatar
   */
  get getUser() {
    if (this.staffId && this.isShowAvatar) {
      if (!this.isLoading) {
        this.isLoading = true;
        this.fetchStaffById(this.staffId)
        this.isLoading = false;
        return this.getStaffById(this.staffId);
      }
    }
    return this.user;
  }

  /**
   * Get information user when show avatar
   */
  async showAvatar(): Promise<void> {
    this.isShowAvatar = true;
  }

}
